import script from "./ScreenSlide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenSlide.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenSlide.vue?vue&type=style&index=0&id=7cf7f9e7&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf7f9e7"]])

export default __exports__